query FontsByClient($clientId: ID!, $orderBy: FontOrderBy) {
    fonts(clientId: $clientId, orderBy: $orderBy) {
        _id
        name
        key
        url
        postScriptName
        signedUrl
        thumbnail
    }
}
